export const HOME_GAMES_QUERY = `
query HomeGames($filter: GameFilter!, $first: Int) {
  casinoGameInventory {
    games(filter: $filter, first: $first) {
      edges {
        node {
          handle
          href
          id
          name
          thumbUrlTab
          volatility
          width
          thumbUrl
          thumbUrlMob
          provider { id name handle }
          category { id name }
          menuItem(section: 1) { handle name }
          isNew
          isFeatured
        }
      }
    }
  }
}
`;
